module.exports = __webpack_public_path__ + "static/media/thumb_stop.904edb3c.svg";